import React, { useState } from "react";
import SaleForm from "./SaleForm";

const Modal = () => {
    const [showModal, setShowModal] = useState(false);

    const closeModal = () => setShowModal(false);

    // const handleCloseButton = (
    //     <button className="model-btn" onClick={closeModal}>
    //         Accept It
    //     </button>
    // );

    // const mainModal = (
    //     <MyModal closeModal={closeModal} handleCloseButton={handleCloseButton}>
    //         <h2>STAY TUNED</h2>
    //         <p>
    //             Subscribe to our newsletter and never miss our designs ,latest news.etc.
    //             Our newsletter is sent once a week, every Monday
    //         </p>
    //     </MyModal>
    // );

    return (
        <div>
            <button className="model-btn" onClick={() => setShowModal(true)}>
                Open Modal
            </button>
            {showModal && <SaleForm closeModal={closeModal} />}
        </div>
    );
};

export default Modal;